
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M265.6 15.6C265.6 7 258.6 0 250 0s-15.6 7-15.6 15.6v29C154.5 52.5 91.9 120 91.9 202v54.8c0 69.4-27.9 98.8-43.4 110-11.2 8.2-22.4 22.2-22.4 40 0 22.7 18.4 41.1 41.1 41.1h116.3c1.6 8.4 5 17.6 10.9 25.9C205.1 489 223.3 500 250 500s44.9-10.9 55.6-26.1c5.9-8.4 9.2-17.5 10.9-25.9h116.3c22.7 0 41.1-18.4 41.1-41.1 0-17.8-11.2-31.8-22.4-40-15.5-11.2-43.4-40.6-43.4-110V202c0-82.1-62.4-149.6-142.4-157.4l-.1-29zm-49.7 432.3c1 2.7 2.3 5.4 4.1 7.9 4.6 6.5 12.9 12.9 30.1 12.9s25.5-6.4 30.1-12.9c1.8-2.5 3.1-5.2 4.1-7.9h-68.4z"}})])
          )
        }
      }
    